// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import * as svgicon from 'vue-svgicon'

import router from './router'
import store from './store'

import App from './containers/App'

import VueJsModal from 'vue-js-modal'

Raven
  .config(process.env.SENTRY_DSN)
  .addPlugin(RavenVue, Vue)
  .install()

Vue.config.productionTip = false

Vue.use(svgicon, {
  classPrefix: 'appicon-'
})

Vue.use(store)

Vue.use(VueJsModal, {
  dialog: true,
  dynamic: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js